var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx, jsxs } from "react/jsx-runtime";
import { theme } from "antd";
import { useDispatch } from "react-redux";
import { setVideoId } from "./../../store/reducers/videoReducer.js";
import VideoPlayButton from "./../videoPlayButton/VideoPlayButton.js";
const VideoBox = ({
  style = { width: "100%" },
  videoId,
  videoPublicUrl,
  videoType,
  children
}) => {
  const { token } = theme.useToken();
  const dispatch = useDispatch();
  const thumbnail = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  const onContainerClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (videoType === 0) {
      return window.open(
        videoPublicUrl || `https://www.youtube.com/watch?v=${videoId}`,
        "_blank"
      );
    }
    dispatch(setVideoId(videoId));
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: __spreadValues({
        display: "block",
        border: "solid 2px",
        borderColor: token.colorBgSolid,
        borderRadius: token.borderRadiusXXS,
        position: "relative",
        aspectRatio: "16/9"
      }, style),
      children: /* @__PURE__ */ jsxs(
        "div",
        {
          onClick: onContainerClick,
          style: {
            cursor: "pointer",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${thumbnail})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          },
          children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "rgba(0,0,0,0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                },
                children: /* @__PURE__ */ jsx(VideoPlayButton, { size: "sm" })
              }
            ),
            children
          ]
        }
      )
    }
  );
};
var stdin_default = VideoBox;
export {
  stdin_default as default
};
